var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotes(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.625 1.875C13.0102 1.875 6.9898 1.875 4.375 1.875C3.8778 1.875 3.4008 2.0726 3.0492 2.4242C2.6976 2.7758 2.5 3.2528 2.5 3.75V16.25C2.5 16.7472 2.6976 17.2242 3.0492 17.5758C3.4008 17.9274 3.8778 18.125 4.375 18.125H11.4084C11.8598 18.125 12.296 17.9622 12.637 17.6664C13.5302 16.8916 15.8808 14.8526 16.8536 14.0088C17.2642 13.6528 17.5 13.136 17.5 12.5924V3.75C17.5 3.2528 17.3024 2.7758 16.9508 2.4242C16.5992 2.0726 16.1222 1.875 15.625 1.875ZM16.25 11.875V3.75C16.25 3.5842 16.1842 3.4252 16.067 3.308C15.9498 3.1908 15.7908 3.125 15.625 3.125H4.375C4.2092 3.125 4.0502 3.1908 3.933 3.308C3.8158 3.4252 3.75 3.5842 3.75 3.75V16.25C3.75 16.4158 3.8158 16.5748 3.933 16.692C4.0502 16.8092 4.2092 16.875 4.375 16.875H10.625V13.75C10.625 12.7144 11.4644 11.875 12.5 11.875H16.25ZM15.9648 13.125H12.5C12.1548 13.125 11.875 13.4048 11.875 13.75V16.6726L15.9648 13.125Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.25 6.25H13.75C14.095 6.25 14.375 5.97 14.375 5.625C14.375 5.28 14.095 5 13.75 5H6.25C5.905 5 5.625 5.28 5.625 5.625C5.625 5.97 5.905 6.25 6.25 6.25Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.25 9.21875H13.75C14.095 9.21875 14.375 8.93855 14.375 8.59375C14.375 8.24875 14.095 7.96875 13.75 7.96875H6.25C5.905 7.96875 5.625 8.24875 5.625 8.59375C5.625 8.93855 5.905 9.21875 6.25 9.21875Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotes);
export default __webpack_public_path__ + "static/media/notes.a2d1b52396d005121f19026195f14f7b.svg";
export { ForwardRef as ReactComponent };